import { render, staticRenderFns } from "./CourseVideoPlayer.vue?vue&type=template&id=5dfa8042"
import script from "./CourseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports